export const getMenusData = (state) => state.MenusData.Data;
